import Script from 'next/script';
import React from 'react';

import { GOOGLE_CONSENT_MODE_SNIPPET, GTAG_SHIM_SNIPPET } from './google-consent-mode';

type GoogleAnalyticsProps = {
    // One or several GA4 measurement IDs. gtag.js is loaded once; each ID gets its own config call.
    trackingId: string | string[];
    // Emits Google Consent Mode v2 signals before the config call. Only enable when the component
    // is rendered exclusively after the visitor granted analytics consent (basic consent mode) —
    // Google requires these signals to populate demographics/audience reports for EEA traffic.
    consentMode?: boolean;
};

function GoogleAnalytics({ trackingId, consentMode }: GoogleAnalyticsProps): React.JSX.Element {
    const trackingIds = [...new Set((Array.isArray(trackingId) ? trackingId : [trackingId]).filter(Boolean))];
    if (trackingIds.length === 0) {
        return null;
    }
    const configSnippet = trackingIds
        .map(
            (id) => `
            window.gtag('config', '${id}', {
              page_path: window.location.pathname,
            });`
        )
        .join('');
    return (
        <>
            <Script
                strategy="afterInteractive"
                src={`https://www.googletagmanager.com/gtag/js?id=${trackingIds[0]}`}
            />
            <Script
                strategy="afterInteractive"
                id="gtag-init-page-specific"
                dangerouslySetInnerHTML={{
                    __html: `${consentMode ? GOOGLE_CONSENT_MODE_SNIPPET : GTAG_SHIM_SNIPPET}
            window.gtag('js', new Date());
${configSnippet}
          `
                }}
            />
        </>
    );
}

export default GoogleAnalytics;
